import script from "./baseData.vue?vue&type=script&setup=true&lang=js"
export * from "./baseData.vue?vue&type=script&setup=true&lang=js"

import "./baseData.vue?vue&type=style&index=0&id=98af5d70&lang=scss&scoped=true"

import exportComponent from "/Users/vadimkholodov/Documents/GitHub/vahta-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-98af5d70"]])

export default __exports__